// // 导入样式文件
import './index.less';
// import { useDrawer } from '@/hooks/DrawerHooks';
// // 导入React hooks
import { useEffect, useState } from 'react';
import AiVoiceProvider from '@/providers/AiVoiceProvider.jsx';
import VoiceList from './components/voicelist/VoiceList';
import PopUp from '@/components/popup/PopUp';
// import { voiceController } from '@/api/index';
import { useDashboardData } from '@/hooks/DashboardHooks';
import { useTranslation } from 'react-i18next';
import Icon from '@/components/iconfont/Icon.jsx';
// 定义Assets组件
export default function Aivoices({ voiceList, setVoiceList, getlist }) {
  const { t } = useTranslation();
  const { userData, setChildCallback } = useDashboardData();
  // const { setIsOpen } = useDrawer();
  // 控制通知显示状态
  const [showNotification, setShowNotification] = useState(false);
  // 控制创建类型模态框显示状态
  const [showCreateTypeModal, setShowCreateTypeModal] = useState(false);
  // 控制上传音频模态框显示状态
  const [showUploadAudioModal, setShowUploadAudioModal] = useState(false);
  // 控制录音模态框显示状态
  const [showRecordAudioModal, setShowRecordAudioModal] = useState(false);
  // 控制音频预览模态框显示状态
  const [showAudioPreviewModal, setShowAudioPreviewModal] = useState(false);
  // 控制修改名称模态框显示状态
  const [showChangeNameModal, setShowChangeNameModal] = useState(false);
  // 控制删除模态框显示状态
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // 当前操作的item
  const [currentItem, setCurrentItem] = useState({});
  // 定义更新列表的时间戳
  const [updateTimestamp, setUpdateTimestamp] = useState(null);
  // 定义新增voices的名字
  const [newVoiceName, setNewVoiceName] = useState('');
  // 录音结束后得到的文件
  const [recordedFile, setRecordedFile] = useState(null);
  const [voiceDeleteTime, setVoiceDeleteTime] = useState(null);
  const [voiceLanguage, setVoiceLanguage] = useState(0);
  const [createVoice, setCreateVoice] = useState(false);
  const providerValue = {
    // 通知显示状态
    showNotification,
    // 设置通知显示状态的函数
    setShowNotification,
    // 创建类型模态框显示状态
    showCreateTypeModal,
    // 设置创建类型模态框显示状态的函数
    setShowCreateTypeModal,
    // 上传音频模态框显示状态
    showUploadAudioModal,
    // 设置上传音频模态框显示状态的函数
    setShowUploadAudioModal,
    // 录音模态框显示状态
    showRecordAudioModal,
    // 设置录音模态框显示状态的函数
    setShowRecordAudioModal,
    // 音频预览模态框显示状态
    showAudioPreviewModal,
    // 设置音频预览模态框显示状态的函数
    setShowAudioPreviewModal,
    // 修改名称模态框显示状态
    showChangeNameModal,
    // 设置修改名称模态框显示状态的函数
    setShowChangeNameModal,
    // 删除模态框显示状态
    showDeleteModal,
    // 设置删除模态框显示状态的函数
    setShowDeleteModal,
    // 当前操作的项目
    currentItem,
    // 设置当前操作项目的函数
    setCurrentItem,
    // 设置更新时间戳的函数
    setUpdateTimestamp,
    // 新的语音名称
    newVoiceName,
    // 设置新的语音名称
    setNewVoiceName,
    // 录音结束后得到的文件
    recordedFile,
    // 设置录音结束后得到的文件
    setRecordedFile,
    userData,
    voiceDeleteTime,
    setVoiceDeleteTime,
    voiceLanguage,
    setVoiceLanguage,
  };
  // 关闭所有popup
  const CloseAllPupUp = (val) => {
    setShowNotification(false);
    setShowCreateTypeModal(false);
    setShowUploadAudioModal(false);
    setShowRecordAudioModal(false);
    setShowAudioPreviewModal(false);
    setShowChangeNameModal(false);
    setShowDeleteModal(false);
    if (val) {
      getlist();
    }
  };
  useEffect(() => {
    const state = canCreateVoice();
    setCreateVoice(state);
  }, []);
  useEffect(() => {
    if (updateTimestamp) getlist();
  }, [updateTimestamp]);
  useEffect(() => {
    if (voiceDeleteTime > 0) {
      getlist();
      setChildCallback(Date.now());
    }
  }, [voiceDeleteTime]);
  useEffect(() => {
    if (showCreateTypeModal) {
      setNewVoiceName(userData?.username + `'s voice`);
    }
  }, [userData, showCreateTypeModal]);
  const [pupUpTime, setPupUpTime] = useState(null);
  useEffect(() => {
    setPupUpTime(new Date().getTime());
  }, [
    showNotification,
    showCreateTypeModal,
    showUploadAudioModal,
    showRecordAudioModal,
    showAudioPreviewModal,
    showChangeNameModal,
    showDeleteModal,
  ]);
  const handleCreate = () => {
    window.onClickGATrackEvent('new-voice-create');
    setShowNotification(true);
  };
  const canCreateVoice = () => {
    const userLevelId = userData.subscription.id;
    // Standar最多克隆3个，Starter最多克隆5个
    const voiceNum = [
      { id: 1, num: 3 },
      { id: 2, num: 5 },
    ];
    const usernum = voiceNum.find((item) => item.id === userLevelId)?.num;
    return [1, 2].includes(userLevelId) && voiceList.length >= usernum;
  };
  return (
    <>
      <button
        disabled={createVoice}
        className="btn btn-active btn-primary btn-xs createVoice no-animation"
        onClick={handleCreate}>
        <Icon name="icon-add-stroke" />
        {t('As_Space_Newvoiceoption')}
      </button>
      <div className="aivoice_box">
        <AiVoiceProvider
          value={{
            voiceList,
            setVoiceList,
            ...providerValue,
            CloseAllPupUp,
            pupUpTime,
            setPupUpTime,
          }}>
          <VoiceList />
          <PopUp />
        </AiVoiceProvider>
      </div>
    </>
  );
}
